import { FC } from 'react'
import { DetailsCellSkeleton } from '@revolut-internal/ui-kit'

import { CollapsibleSection } from 'components'
import { AiDebugProcess } from 'lib/apiClient'
import { DEBUG_ACTION_NAME } from 'pages/AiProcessDebugV2/AiProcessDebug.constants'
import { mapTransactionsData } from 'pages/AiProcessDebugV2/utils'

import { EmptyTracesWidget } from '../EmptyTracesWidget/EmptyTracesWidget'
import { PromptTransactionsContext } from '../Trace/PromptTransactionsContext'
import { TraceAction } from '../TraceAction'

interface IDebugDetailsContentProps {
  selectedProcessData: AiDebugProcess | null
}

export const DebugDetailsContent: FC<IDebugDetailsContentProps> = ({
  selectedProcessData,
}) => {
  if (!selectedProcessData?.traces) {
    return <DetailsCellSkeleton />
  }

  if (selectedProcessData?.traces.length === 0) {
    return <EmptyTracesWidget />
  }

  return selectedProcessData.traces.map(action => (
    <CollapsibleSection
      key={action.name}
      name={`${action.name} (${action.duration}s)`}
      initialOpen={action.name === DEBUG_ACTION_NAME}
    >
      <PromptTransactionsContext.Provider
        value={
          action.name === DEBUG_ACTION_NAME
            ? mapTransactionsData(selectedProcessData)
            : undefined
        }
      >
        <TraceAction {...action} />
      </PromptTransactionsContext.Provider>
    </CollapsibleSection>
  ))
}
